import {MESSAGE_TYPE} from '../app.constants';
import {MessageLink} from './message-link.model';

export abstract class Message {

    type: string;
    title: string;
    category?: string;
    content?: string;
    path?: string;
    icon?: string;
    date?: string;
    link: MessageLink;
    persistent?: boolean;

    protected constructor(
        type: MESSAGE_TYPE,
        icon: string,
        title: string,
        content?: string,
        path?: string,
        date?: string,
        link?: MessageLink,
        persistent?: boolean,
    ) {
        this.type = type;
        this.icon = icon;
        this.title = title;
        this.content = content;
        this.path = path;
        this.date = date;
        this.link = link;
        this.persistent = persistent;
    }
}
